(() => {
  const moneyFormat =
    (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format) ||
    (window.theme && window.theme.settings && window.theme.settings.money_format) ||
    (window.Shopify && window.Shopify.money_format) ||
    '${{amount}}';

  const addToCartText =
    (window.theme && window.theme.variantStrings && window.theme.variantStrings.addToCart) ||
    'Add to cart';
  const soldOutText =
    (window.theme && window.theme.variantStrings && window.theme.variantStrings.soldOut) ||
    'Sold out';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    const n = (Number(cents) || 0) / 100;
    return n.toFixed(2);
  }

  function stripHtml(html) {
    const div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || div.innerText || '').trim();
  }

  function truncate(str, max) {
    const s = (str || '').trim();
    if (s.length <= max) return s;
    return s.slice(0, max).trim() + '...';
  }

  function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML || '';
  }

  async function fetchProductByHandle(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  function positionPopup(sectionEl, popupEl, containerEl, hotspotButtonEl) {
    if (window.innerWidth <= 575) {
      popupEl.removeAttribute('style');
      return;
    }

    const hotspotRect = hotspotButtonEl.getBoundingClientRect();
    const containerRect = containerEl.getBoundingClientRect();

    const popupWidth = 320;
    const offset = 25;

    const hotspotX = hotspotRect.left - containerRect.left + hotspotRect.width / 2;
    const hotspotY = hotspotRect.top - containerRect.top + hotspotRect.height / 2;

    let left = hotspotX + offset;
    let top = hotspotY - popupEl.offsetHeight / 2;

    if (left + popupWidth > containerRect.width) {
      left = hotspotX - offset - popupWidth;
    }

    const minTop = 10;
    const maxTop = containerRect.height - popupEl.offsetHeight - 10;
    top = Math.max(minTop, Math.min(top, maxTop));

    popupEl.style.left = left + 'px';
    popupEl.style.top = top + 'px';
  }

  function initOne(sectionEl) {
    const containerEl = sectionEl.querySelector('.dpt-product-hotspot-image__image-inner');
    const popupEl = sectionEl.querySelector('[data-dpt-hotspot-popup]');
    const overlayEl = sectionEl.querySelector('[data-dpt-hotspot-overlay]');
    const closeBtnEl = sectionEl.querySelector('[data-dpt-hotspot-close]');
    const mountEl = sectionEl.querySelector('[data-dpt-hotspots-mount]');
    const jsonEl = sectionEl.querySelector('[data-dpt-hotspots-json]');
    const imageContainerEl = sectionEl.querySelector('.dpt-product-hotspot-image__image-container');

    const imageLinkEl = sectionEl.querySelector('[data-dpt-popup-image-link]');
    const imagePlaceholderEl = sectionEl.querySelector('[data-dpt-popup-image-placeholder]');
    let imageEl = null;
    const titleEl = sectionEl.querySelector('[data-dpt-popup-title]');
    const descEl = sectionEl.querySelector('[data-dpt-popup-desc]');
    const formEl = sectionEl.querySelector('[data-dpt-popup-form]');
    const variantInputEl = sectionEl.querySelector('[data-dpt-popup-variant-id]');
    const atcLabelEl = sectionEl.querySelector('[data-dpt-popup-atc-label]');
    const errorEl = sectionEl.querySelector('[data-dpt-popup-error]');

    const productCache = new Map();
    let activeButton = null;

    function closePopup() {
      sectionEl.classList.remove('is-open');
      popupEl.setAttribute('aria-hidden', 'true');
      popupEl.removeAttribute('style');
      sectionEl.querySelectorAll('[data-dpt-hotspot]').forEach((h) => h.classList.remove('is-active'));
      activeButton = null;
    }

    async function openPopup(buttonEl) {
      const handle = buttonEl.getAttribute('data-product-handle');
      if (!handle) return;

      // Clear all popup content before loading new data
      if (titleEl) {
        titleEl.textContent = '';
        titleEl.setAttribute('href', '#');
      }
      // Remove any existing image and show the placeholder spinner
      if (imageEl && imageEl.parentNode) {
        imageEl.parentNode.removeChild(imageEl);
        imageEl = null;
      }
      if (imagePlaceholderEl) imagePlaceholderEl.style.display = '';
      if (imageLinkEl) imageLinkEl.setAttribute('href', '#');
      if (descEl) descEl.textContent = '';
      if (variantInputEl) {
        variantInputEl.value = '';
        variantInputEl.disabled = true;
      }
      if (atcLabelEl) atcLabelEl.textContent = '';
      if (formEl) {
        formEl.style.display = 'none';
        const submitButton = formEl.querySelector('.single-add-to-cart-button');
        if (submitButton) {
          submitButton.setAttribute('disabled', 'true');
          submitButton.disabled = true;
        }
      }
      if (errorEl) errorEl.hidden = true;

      sectionEl.querySelectorAll('[data-dpt-hotspot]').forEach((h) => h.classList.remove('is-active'));
      buttonEl.classList.add('is-active');
      activeButton = buttonEl;

      sectionEl.classList.add('is-open');
      popupEl.setAttribute('aria-hidden', 'false');

      if (window.innerWidth > 575) positionPopup(sectionEl, popupEl, containerEl, buttonEl);

      const prodPromise = productCache.get(handle) || fetchProductByHandle(handle);
      productCache.set(handle, prodPromise);
      const prod = await prodPromise;

      if (!prod) {
        if (titleEl) {
          titleEl.textContent = 'Product unavailable';
          titleEl.setAttribute('href', '#');
        }
        if (descEl) descEl.textContent = '';
        if (formEl) formEl.style.display = 'none';
        return;
      }

      // Find first available variant, or first variant if none available
      const variants = prod.variants || [];
      let variant = variants.find((v) => v.available === true) || variants[0];

      const priceText = formatMoney(variant ? variant.price : prod.price || 0);

      if (titleEl) {
        titleEl.textContent = prod.title;
        titleEl.setAttribute('href', prod.url);
      }

      const imgSrc = prod.featured_image || (prod.images && prod.images[0]) || '';
      if (imageLinkEl) imageLinkEl.setAttribute('href', prod.url);

      // Preload the image, then swap the placeholder for the real <img>
      if (imgSrc && imageLinkEl) {
        const img = new Image();
        img.className = 'dpt-product-hotspot-image__popup-image';
        img.alt = prod.title;
        img.width = 95;
        img.height = 95;
        img.style.display = 'block';
        img.onload = function() {
          if (imagePlaceholderEl) imagePlaceholderEl.style.display = 'none';
          imageLinkEl.appendChild(img);
          imageEl = img;
        };
        img.onerror = function() {
          // If image fails to load, just hide the placeholder quietly
          if (imagePlaceholderEl) imagePlaceholderEl.style.display = 'none';
        };
        img.src = imgSrc;
      } else if (imagePlaceholderEl) {
        imagePlaceholderEl.style.display = 'none';
      }

      if (descEl) {
        descEl.textContent = truncate(stripHtml(prod.description || prod.body_html || ''), 120);
      }

      // Check variant availability
      const isAvailable = variant && (variant.available === true || variant.available == null);

      if (isAvailable && variant && variantInputEl && atcLabelEl) {
        variantInputEl.value = variant.id;
        variantInputEl.disabled = false;
        atcLabelEl.textContent = `${addToCartText} · ${priceText}`;
        if (formEl) {
          formEl.style.display = 'block';
          const submitButton = formEl.querySelector('.single-add-to-cart-button');
          if (submitButton) {
            submitButton.removeAttribute('disabled');
            submitButton.disabled = false;
          }
        }
      } else {
        if (atcLabelEl) atcLabelEl.textContent = soldOutText;
        if (formEl) {
          formEl.style.display = 'block';
          const submitButton = formEl.querySelector('.single-add-to-cart-button');
          if (submitButton) {
            submitButton.setAttribute('disabled', 'true');
            submitButton.disabled = true;
          }
        }
      }

      if (window.innerWidth > 575 && activeButton) positionPopup(sectionEl, popupEl, containerEl, activeButton);
    }

    function makeHotspotEl(h) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dpt-product-hotspot-image__hotspot';
      btn.style.left = `${h.x}%`;
      btn.style.top = `${h.y}%`;
      btn.setAttribute('data-product-handle', h.product_handle);
      btn.setAttribute('data-dpt-hotspot', '');
      btn.innerHTML = `
        <span class="dpt-product-hotspot-image__hotspot-ring">
          <span class="dpt-product-hotspot-image__hotspot-dot">
            <span class="dpt-product-hotspot-image__hotspot-icon">+</span>
          </span>
        </span>
      `;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (sectionEl.classList.contains('is-open') && btn.classList.contains('is-active')) {
          closePopup();
          return;
        }
        openPopup(btn);
      });

      return btn;
    }

    function init() {
      let hotspots = [];
      try {
        hotspots = JSON.parse(jsonEl.textContent || '[]');
      } catch {
        hotspots = [];
      }

      mountEl.innerHTML = '';
      hotspots
        .filter((h) => h && h.enabled && typeof h.x === 'number' && typeof h.y === 'number' && h.product_handle)
        .forEach((h) => mountEl.appendChild(makeHotspotEl(h)));

      if (closeBtnEl) {
        closeBtnEl.addEventListener('click', closePopup);
      }
      if (overlayEl) {
        overlayEl.addEventListener('click', closePopup);
      }
      
      // Also handle clicks on the image container (for areas not covered by hotspots)
      if (imageContainerEl) {
        imageContainerEl.addEventListener('click', (e) => {
          // Only close if clicking directly on the container or overlay, not on hotspots or popup
          if (sectionEl.classList.contains('is-open')) {
            const target = e.target;
            const isHotspot = target.closest('[data-dpt-hotspot]');
            const isPopup = target.closest('[data-dpt-hotspot-popup]');
            const isOverlay = target === overlayEl || target.closest('[data-dpt-hotspot-overlay]');
            
            if (!isHotspot && !isPopup && isOverlay) {
              closePopup();
            }
          }
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closePopup();
      });

      window.addEventListener('resize', () => {
        if (!sectionEl.classList.contains('is-open') || !activeButton) return;
        positionPopup(sectionEl, popupEl, containerEl, activeButton);
      });

      // Handle form submission with AJAX
      if (formEl) {
        formEl.addEventListener('submit', async (e) => {
          e.preventDefault();
          const submitButton = formEl.querySelector('.single-add-to-cart-button');
          const variantInput = formEl.querySelector('[data-dpt-popup-variant-id]');

          if (!variantInput || !variantInput.value) return;

          if (submitButton) {
            submitButton.classList.add('loading');
            submitButton.setAttribute('aria-disabled', 'true');
            submitButton.disabled = true;
          }

          if (errorEl) {
            errorEl.hidden = true;
          }

          try {
            const formData = new FormData();
            formData.append('id', variantInput.value);
            formData.append('quantity', 1);
            formData.append('sections', 'cart-drawer,cart-bubble');
            formData.append('sections_url', window.location.pathname);

            const response = await fetch(
              (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js',
              {
                method: 'POST',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  Accept: 'application/json',
                },
                body: formData,
              }
            );

            const data = await response.json();

            if (data.status) {
              // Error occurred
              if (errorEl) {
                const errorMsg = errorEl.querySelector('.error-message');
                if (errorMsg) {
                  errorMsg.textContent = data.description || 'An error occurred';
                }
                errorEl.hidden = false;
              }
              return;
            }

            // Success - update cart drawer and open it
            if (data.sections) {
              const cartDrawer = document.getElementById('Cart-Drawer');
              const cartBubble = document.getElementById('cart-drawer-toggle');

              if (cartDrawer && data.sections['cart-drawer']) {
                const drawerContent = cartDrawer.querySelector('.cart-drawer') || cartDrawer;
                drawerContent.innerHTML = getSectionInnerHTML(data.sections['cart-drawer'], '.cart-drawer');
                if (typeof cartDrawer.removeProductEvent === 'function') {
                  cartDrawer.removeProductEvent();
                }
              }

              if (cartBubble && data.sections['cart-bubble']) {
                const bubbleContent = cartBubble.querySelector('.thb-item-count');
                if (bubbleContent) {
                  bubbleContent.innerHTML = getSectionInnerHTML(data.sections['cart-bubble'], '.thb-item-count');
                }
              }

              // Reinitialize cart if Cart class exists
              if (typeof Cart !== 'undefined' && data.sections) {
                new Cart().renderContents(data);
              }
            }

            // Open cart drawer
            const cartDrawerEl = document.getElementById('Cart-Drawer');
            if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
              cartDrawerEl.open();
            } else if (cartDrawerEl) {
              document.body.classList.add('open-cc');
              cartDrawerEl.classList.add('active');
              cartDrawerEl.focus();
            }

            // Dispatch custom event
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:item-added', {
                bubbles: true,
                detail: {
                  product: data.hasOwnProperty('items') ? data.items[0] : data,
                },
              })
            );

            // Close popup after successful add
            closePopup();
          } catch (error) {
            console.error('Add to cart error:', error);
            if (errorEl) {
              const errorMsg = errorEl.querySelector('.error-message');
              if (errorMsg) {
                errorMsg.textContent = 'An error occurred. Please try again.';
              }
              errorEl.hidden = false;
            }
          } finally {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
              submitButton.disabled = false;
            }
          }
        });
      }
    }

    init();
  }

  function initAll() {
    document.querySelectorAll('[data-dpt-product-hotspot-image]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
